import { yearFirstPluralLowercase } from 'owa-locstrings/lib/strings/yearfirstplurallowercase.locstring.json';
import { yearSingularLowercase } from 'owa-locstrings/lib/strings/yearsingularlowercase.locstring.json';
import { monthFirstPluralLowercase } from 'owa-locstrings/lib/strings/monthfirstplurallowercase.locstring.json';
import { monthSingularLowercase } from 'owa-locstrings/lib/strings/monthsingularlowercase.locstring.json';
import { dayFirstPluralLowercase } from 'owa-locstrings/lib/strings/dayfirstplurallowercase.locstring.json';
import { daySingularLowercase } from 'owa-locstrings/lib/strings/daysingularlowercase.locstring.json';
import {
    retentionPolicies_periodNeverExpireText,
    retentionPolicies_periodText,
    retentionPolicies_periodYearsMonthsText,
} from './getRetentionDuration.locstring.json';
import loc, { format } from 'owa-localize';
import RetentionPolicyTagDisplay from 'owa-service/lib/contract/RetentionPolicyTagDisplay';

/**
 * Gets the retention duration based on the age limit param
 * @param AgeLimitForRetentionDays
 */
export default function getRetentionDuration({
    AgeLimitForRetentionDays: ageLimitForRetentionDays,
}: RetentionPolicyTagDisplay): string {
    if (!ageLimitForRetentionDays) {
        return null;
    }
    return (
        getDayDurationBasedOnAgeLimit(ageLimitForRetentionDays) ||
        getMonthYearDurationBasedOnAgeLimit(ageLimitForRetentionDays)
    );
}

export function getDayDurationBasedOnAgeLimit(ageLimitForRetentionDays: number): string {
    return ageLimitForRetentionDays == 0
        ? loc(retentionPolicies_periodNeverExpireText)
        : ageLimitForRetentionDays < 90
        ? format(
              loc(retentionPolicies_periodText),
              ageLimitForRetentionDays,
              getDayString(ageLimitForRetentionDays)
          )
        : null;
}

export function getMonthYearDurationBasedOnAgeLimit(ageLimitForRetentionDays: number): string {
    const years = Math.floor(ageLimitForRetentionDays / 365);
    const months = Math.floor((ageLimitForRetentionDays % 365) / 30);
    const monthsPart = format(loc(retentionPolicies_periodText), months, getMonthString(months));
    const yearsPart = format(loc(retentionPolicies_periodText), years, getYearString(years));
    return years != 0 && months != 0
        ? format(loc(retentionPolicies_periodYearsMonthsText), yearsPart, monthsPart)
        : years != 0
        ? yearsPart
        : monthsPart;
}

function getDayString(day: number): string {
    return day == 1 ? loc(daySingularLowercase) : loc(dayFirstPluralLowercase);
}

function getMonthString(month: number): string {
    return month == 1 ? loc(monthSingularLowercase) : loc(monthFirstPluralLowercase);
}

function getYearString(year: number): string {
    return year == 1 ? loc(yearSingularLowercase) : loc(yearFirstPluralLowercase);
}
